<template>
  <div class="homepage-header-pc-swiper_content">
    <no-ssr>
      <el-carousel
        :interval="5000"
        :duration="400"
        :height="'400px'"
        arrow="always"
      >
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <nuxt-link
            :to="`/company/${companyId}/promotion/${item.targetId}`"
            :target="$_newtab"
            append
          >
            <div class="pc-swiper_image">
              <img :src="item.url" />
            </div>
          </nuxt-link>
        </el-carousel-item>
      </el-carousel>
    </no-ssr>
  </div>
</template>

<style lang="scss">
.homepage-header-pc-swiper_content {
  .pc-swiper_image {
    width: 100%;
    flex-basis: 60%;
    img {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }
  }
  .el-carousel__item {
    text-align: center;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .el-carousel__arrow--right {
    right: 0px;
  }

  .el-carousel__arrow--left {
    left: 0px;
  }
  .el-carousel__arrow {
    border-radius: 0%;
    height: 100px;
    width: 60px;
  }
}
</style>

<script>
export default {
  props: {
    companyId: {
      type: [String, Number],
      default: ''
    },
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      height: 200
    }
  },
  methods: {}
}
</script>
